import { FC, useEffect, useState } from 'react';

export type CountdownProps = {
  seconds: number;
};

export const Countdown: FC<CountdownProps> = ({ seconds = 0 }) => {
  const [secondsLeft, setSecondsLeft] = useState(seconds);

  useEffect(() => {
    const intId = setInterval(() => {
      setSecondsLeft((secondsLeft) => secondsLeft - 1);
    }, 1000);

    return () => {
      clearInterval(intId);
    };
  }, [seconds]);

  return secondsLeft;
};
